export const AppConfig = {
  disablePremiumRestrictions: true,
} as const;
